import React from 'react';
import './WarningAlert.css';  

const WarningAlert = ({ title, description, onConfirm, onCancel }) => {
    return (
        <div className="warning-alert">
            <div className="warning-alert-content">
                <h3>{title}</h3>
                <p>{description}</p>
                <div className="warning-alert-buttons">
                    <button className="yes-button" onClick={onConfirm}>Yes</button>
                    <button className="no-button" onClick={onCancel}>No</button>
                </div>
            </div>
        </div>
    );
};

export default WarningAlert;
